import { Component } from "@angular/core";
import { RiveModule } from "ng-rive";

@Component({
  selector: "app-rive",
  standalone: true,
  imports: [RiveModule],
  template: `
    <canvas riv="coin" width="320" height="320">
      <riv-animation name="rotazione" play></riv-animation>
    </canvas>
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    canvas {
      max-width: 100%;
      height: auto;
    }
  `,
})
export class RiveComponent {}
